const taglineStyle = (theme) => ({
	tagline: {
		fontStyle: 'italic',
		letterSpacing: -theme.spacing.unit / 7,
		color: '#d3d3d3'
	}
});
export default taglineStyle;



// WEBPACK FOOTER //
// ./src/styles/taglineStyle.js